// src\themes\lino\elements\footer\Newsletter.tsx
"use client";

import { Loader2, ArrowLeft } from "lucide-react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import TextInput from "@/components/account/input/TextInput";
import { newsletterSubscribe } from "@/core/lib/api/main/landing";
import { emailSchema, EmailSchemaData } from "@/core/schemas/newsletterSchema";
import { useDictionary } from "@/core/hooks/use-dictionary";

export default function Newsletter() {
  const { dictionary } = useDictionary();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<EmailSchemaData>({
    resolver: zodResolver(emailSchema),
  });

  const onSubmit = async (data: EmailSchemaData) => {
    try {
      const result = await newsletterSubscribe({ email: data.email });

      if (result?.status === "success") {
        toast.success(result.message);
        reset();
      } else if (result.status === "validation_error" && result.data) {
        toast.error(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("خطا در ثبت");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <span className="block mb-1.5 text-[11px] uppercase tracking-[0.14em] text-primary-500">
        {dictionary.ui?.newsletter.title}
      </span>
      <p className="text-[13px] text-primary-600 mb-5 leading-6">
        {dictionary.ui?.newsletter.description}
      </p>
      <div className="relative border-b border-primary-900 focus-within:border-primary-900">
        <TextInput
          label=""
          placeholder={dictionary.ui?.newsletter.placeholder}
          errors={errors}
          register={register}
          name={"email"}
          variant="secondary"
          inputClassName="w-full !rounded-none !border-0 !border-b-0 !bg-transparent px-0 pl-10 focus:!ring-0"
        />
        <button
          type="submit"
          className="absolute top-1/2 -translate-y-1/2 rtl:left-0 ltr:right-0 w-8 h-8 flex items-center justify-center text-primary-900 disabled:opacity-50"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
          ) : (
            <ArrowLeft className="w-3.5 h-3.5 rtl:rotate-180" />
          )}
        </button>
      </div>
    </form>
  );
}